import { Injectable } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest.service';
import { AutomationAPI } from '@core/typings/api/automation.typing';
import { PaginatedResponse, PaginationOptions } from '@yourcause/common';
import { BudgetAssignmentApplicationHistory, BudgetAssignmentRuleSetDetail, BudgetAssignmentSequenceModel, SaveBudgetAssignmentRuleSet, SimpleBudgetAssignmentRuleSet } from './budget-assignments.typing';

@Injectable({ providedIn: 'root' })
export class BudgetAssignmentsResources {
  constructor (
    private http: HttpRestService
  ) { }

  updateApplicationBudgetFundingSource (
    applicationId: number,
    budgetId: number,
    fundingSourceId: number,
    isReserved: boolean
  ) {
    const endpoint = `api/manager/applications/${applicationId}/UpdateBudgetFundingSource`;

    return this.http.post(endpoint, {
      budgetId,
      fundingSourceId,
      isReserved
    });
  }

  getPaginatedList (paginationOptions: PaginationOptions<SimpleBudgetAssignmentRuleSet>): Promise<PaginatedResponse<SimpleBudgetAssignmentRuleSet>> {
    return this.http.post('/api/manager/BudgetAssignmentAutomation/Paginated', { paginationOptions });
  }

  getDetail (id: number): Promise<BudgetAssignmentRuleSetDetail> {
    const endpoint = '/api/manager/BudgetAssignmentAutomation/' + id;

    return this.http.get(endpoint);
  }

  changeStatus (id: number, status: AutomationAPI.AutomationRuleSetStatus): Promise<void> {
    const endpoint = '/api/manager/BudgetAssignmentAutomation/' + id + '/Status';

    return this.http.post(endpoint, {
      status
    });
  }

  deleteRuleSet (id: number): Promise<void> {
    const endpoint = '/api/manager/BudgetAssignmentAutomation/' + id;

    return this.http.delete(endpoint);
  }

  saveRuleSet (ruleSet: SaveBudgetAssignmentRuleSet): Promise<SimpleBudgetAssignmentRuleSet> {
    const endpoint = '/api/manager/BudgetAssignmentAutomation';

    return this.http.post(endpoint, ruleSet);
  }

  sequence (sequence: BudgetAssignmentSequenceModel): Promise<void> {
    const endpoint = '/api/manager/BudgetAssignmentAutomation/Sequence';

    return this.http.post(endpoint, sequence);
  }

  getBudgetAssignmentHistory (
    paginationOptions: PaginationOptions<any>,
    budgetAssignmentAutomationRuleSetId: number
  ): Promise<PaginatedResponse<BudgetAssignmentApplicationHistory>> {
    const endpoint = '/api/manager/BudgetAssignmentAutomation/Applications';

    return this.http.post(endpoint, {
      paginationOptions,
      budgetAssignmentAutomationRuleSetId
    });
  }

  changeRuleSetStatusBulk (ids: number[], status: AutomationAPI.AutomationRuleSetStatus) {
    const endpoint = '/api/manager/BudgetAssignmentAutomation/BulkUpdateBudgetAssignmentAutomationRuleSetStatus';

    return this.http.post(endpoint, {
      ids,
      status
    });
  }
}
